import httpAuth from '@/services/httpAuth'
import { serialize } from '@/services/object'

let infoData = false
export async function info () {
  if (!infoData) infoData = await httpAuth.get(`/acessofuncionalidade/info`, { tela: 'acesso_funcionalidade' })
  return infoData
}

export async function list (filtros) {
  return httpAuth.get(`/acessofuncionalidade?${serialize(filtros)}`, { tela: 'acesso_funcionalidade' })
}

export async function get (id) {
  return httpAuth.get(`/acessofuncionalidade/${id}`, { tela: 'acesso_funcionalidade' })
}

export async function add (dados) {
  return httpAuth.post(`/acessofuncionalidade`, dados, { funcionalidade: 'acesso_funcionalidade_incluir' })
}

export async function edit (id, dados) {
  return httpAuth.put(`/acessofuncionalidade/${id}`, dados, { funcionalidade: 'acesso_funcionalidade_editar' })
}

export async function del (id) {
  return httpAuth.delete(`/acessofuncionalidade/${id}`, { funcionalidade: 'acesso_funcionalidade_excluir' })
}
